import React, { useState, useEffect } from 'react';
import Link from '../components/Link';
import { motion } from 'framer-motion';
import { User, Mail, Lock, Trash2, Edit2, LogOut, User2 } from 'lucide-react';
// import { supabase } from '../lib/supabase';
import { checkLoginStatus, getUserData, updateUserData, logoutUser } from '../api/authService';
import { Toast, ToastContainer } from '../components/Toast';

const supabase = []
const navigate = (url) => {
  window.location.href = url;
}

function Profile() {
  return (
    <div className="min-h-screen">
      <Profile_page />
    </div>
  )
}

function Profile_page() {
  const [user, setUser] = useState([]);
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    display_name: '',
    email: '',
    new_password: '',
    confirm_password: '',
  });

  useEffect(() => {
    fetchUserData();
    fetchUserComments();
  }, []);

  const fetchUserData = async () => {
    const loggedIn = await checkLoginStatus();
    if (!loggedIn) {
      window.location.href = "/login";
      return;
    }
    try {
      const userData = await getUserData();
      if (!userData) {
        Toast.error('Error fetching user:');
        return;
      }
      setUser(userData);
      setFormData({
        display_name: userData.nickname || '',
        email: userData.email || '',
        new_password: '',
        confirm_password: '',
      });
    } catch (error) {
      Toast.error('Error fetching user:', error);
      navigate('/login');
    } finally {
      setIsLoading(false);
    }
  };


  const fetchUserComments = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: comments, error } = await supabase
        .from('comments')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      setComments(comments || []);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    Toast.info("We’re still working on this page. This feature isn’t available yet, but it’s coming soon. Thanks for your patience!");
    setTimeout(() => {
      setIsLoading(false)
    }, 1000);

    // try {
    //   const updates = {
    //     email: formData.email,
    //     data: { display_name: formData.display_name },
    //   };

    //   const { error } = await supabase.auth.updateUser(updates);
    //   if (error) throw error;

    //   if (formData.new_password) {
    //     if (formData.new_password !== formData.confirm_password) {
    //       throw new Error('Passwords do not match');
    //     }

    //     const { error: passwordError } = await supabase.auth.updateUser({
    //       password: formData.new_password,
    //     });

    //     if (passwordError) throw passwordError;
    //   }

    //   toast.success('Profile updated successfully');
    //   setEditMode(false);
    //   fetchUserData();
    // } catch (error) {
    //   toast.error(error.message || 'Failed to update profile');
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const { error } = await supabase
        .from('comments')
        .delete()
        .eq('id', commentId);

      if (error) throw error;

      Toast.success('Comment deleted successfully');
      fetchUserComments();
    } catch (error) {
      Toast.error(error.message || 'Failed to delete comment');
    }
  };

  const handleSignOut_ = async () => {
    try {
      const { success, error } = await logoutUser();
      if (!success) throw new Error(error);
    } catch (error) {
      Toast.error('Failed to sign out: ' + error.message);
    }
  };


  // const handleSignOut___ = async () => {
  //   // Show confirmation toast
  //   const confirmLogout = await new Promise((resolve) => {
  //     const toastId = Toast.info(
  //       <div>
  //         <p>Are you sure you want to log out?</p>
  //         <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  //           <button onClick={() => { Toast.dismiss(toastId); resolve(true); }} style={yesButtonStyle}>Yes</button>
  //           <button onClick={() => { Toast.dismiss(toastId); resolve(false); }} style={noButtonStyle}>No</button>
  //         </div>
  //       </div>,
  //       { autoClose: false, closeOnClick: false, draggable: false }
  //     );
  //   });

  //   if (!confirmLogout) return; // Cancel logout if user selects "No"

  //   try {
  //     await Toast.promise(
  //       logoutUser(),
  //       {
  //         pending: "Logging out...",
  //         success: "Successfully logged out!",
  //         error: "Failed to sign out.",
  //       }
  //     );
  //   } catch (error) {
  //     Toast.error('Failed to sign out: ' + error.message);
  //   }
  // };

  const handleSignOut = async () => {
    Toast.callBack.warning("Are you sure you want to log out?", {
      onConfirm: async () => {
        try {
          const { success, error } = await logoutUser();
          if (!success) throw new Error(error);
        } catch (error) {
          Toast.error("Failed to sign out: " + error.message);
        }
      },
      onCancel: () => {
        Toast.info("Logout cancelled.");
      }
    });
  };


  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="flex justify-between items-center mb-8">
              <h1 className="text-3xl font-bold">Profile</h1>
              <div className="flex space-x-4">
                {(user?.roles?.includes('editor') || user?.roles?.includes('administrator')) && (
                  <motion.button
                    onClick={() => {window.location.href = "/admin";}}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="flex items-center space-x-2 px-4 py-2 bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors"
                  >
                    <User2 className="w-4 h-4" />
                    <span>Admin</span>
                  </motion.button>
                )}
                <motion.button
                  onClick={() => setEditMode(!editMode)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="flex items-center space-x-2 px-4 py-2 bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors"
                >
                  <Edit2 className="w-4 h-4" />
                  <span>{editMode ? 'Cancel' : 'Edit Profile'}</span>
                </motion.button>
                <motion.button
                  onClick={handleSignOut}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="flex items-center space-x-2 px-4 py-2 bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Sign Out</span>
                </motion.button>
              </div>
            </div>

            {editMode ? (
              <form onSubmit={handleUpdateProfile} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2">Display Name</label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="text"
                      name="display_name"
                      value={formData.display_name}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Email</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">New Password</label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="password"
                      name="new_password"
                      value={formData.new_password}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                      placeholder="Leave blank to keep current password"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Confirm New Password</label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="password"
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                      placeholder="Leave blank to keep current password"
                    />
                  </div>
                </div>

                <motion.button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-3 bg-gradient-to-r from-tc-gold to-orange-600 text-white rounded-lg hover:from-amber-400 hover:to-orange-700 transition-all duration-300 flex items-center justify-center space-x-2"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span>{isLoading ? 'Updating...' : 'Update Profile'}</span>
                </motion.button>
              </form>
            ) : (
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Display Name</label>
                  <p className="text-lg">{user.nickname}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-400 mb-1">Email</label>
                  <p className="text-lg">{user.email}</p>
                </div>
              </div>
            )}
          </div>

          <div className="mt-8 bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <h2 className="text-2xl font-bold mb-6">Your Comments</h2>
            {comments.length > 0 ? (
              <div className="space-y-4">
                {comments.map((comment) => (
                  <motion.div
                    key={comment.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white/5 rounded-lg p-4 flex justify-between items-start"
                  >
                    <div>
                      <p className="text-gray-300">{comment.content}</p>
                      <p className="text-sm text-gray-500 mt-1">
                        {new Date(comment.created_at).toLocaleDateString()}
                      </p>
                    </div>
                    <motion.button
                      onClick={() => handleDeleteComment(comment.id)}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="text-red-500 hover:text-red-400 transition-colors"
                    >
                      <Trash2 className="w-5 h-5" />
                    </motion.button>
                  </motion.div>
                ))}
              </div>
            ) : (
              <p className="text-gray-400">You haven't made any comments yet.</p>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const Profile_ = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const loggedIn = await checkLoginStatus();
      if (!loggedIn) {
        navigate("/login");
        return;
      }
      try {
        const userData = await getUserData();
        setUser(userData);
      } catch (err) {
        setError("Failed to load user data");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [navigate]);

  const handleUpdate = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await updateUserData(user);
      alert("Profile updated successfully");
    } catch (err) {
      setError("Failed to update profile");
    }
    setLoading(false);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Profile</h2>
      <form onSubmit={handleUpdate}>
        <label className="block mb-2">
          Name:
          <input
            type="text"
            value={user?.name || ""}
            onChange={(e) => setUser({ ...user, name: e.target.value })}
            className="border p-2 w-full"
          />
        </label>
        <label className="block mb-2">
          Email:
          <input
            type="email"
            value={user?.email || ""}
            disabled
            className="border p-2 w-full bg-gray-200"
          />
        </label>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded mt-4"
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Profile"}
        </button>
      </form>
    </div>
  );
};


export default Profile;